import styled from '@emotion/styled'

import { Button as ButtonComponent, ButtonLink as ButtonLinkComponent } from '@/components/Button'

import { BodyM } from '@/components/Typography'

import { CONFIG } from '@/styles/emotion.config'

import { ButtonsWrapper, Cta } from '../styles'

export const Container = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
  gap: 1rem;
`

export const Button = styled(ButtonComponent)`
  flex-wrap: nowrap;
  white-space: nowrap;
  width: auto;
  padding: 0 !important;
`

export const ButtonLink = Cta.withComponent(ButtonLinkComponent)

export const Paragraph = styled(BodyM)`
  margin: 0 0.25rem;
`

export const Divider = styled.hr`
  margin: 0;
`

export const Wrapper = styled(ButtonsWrapper)`
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  margin-top: 0.5rem;

  ${CONFIG.media.mobileMd} {
    flex-direction: column;
  }
`
